import React, { useEffect, useRef, useState } from 'react'
import Highcharts from 'highcharts'

import xrange from 'highcharts/modules/xrange'
import HighchartsReact from 'highcharts-react-official'
import styled from 'styled-components'
import { mountChartCategories, mountChartSeries, renderPointForm } from './utils'
import { borderColor, borderWidth } from 'polished'

xrange(Highcharts)
const TrackBar = (props: LiveReactChartProps<ChartState>): JSX.Element => {
    const { state, width, height, widget } = props
    const chartRef = useRef(null)
    const [series, setSeries] = useState([])
    const [categories, setCategories] = useState([])

    useEffect(() => {
        if (state?.endHistory) {
            setSeries(mountChartSeries(state, props.width))
            setCategories(mountChartCategories(state))
        }
    }, [state?.endHistory])

    useEffect(() => {
        if (series.length > 0) {
            chartRef?.current?.chart.redraw()
            chartRef?.current?.chart.reflow()
        }
    }, [series])

    useEffect(() => {
        if (chartRef?.current?.chart) {
            setSeries(mountChartSeries(state, props.width))
            chartRef.current.chart.reflow()
        }
    }, [width, height])

    return (
        <Container>
            {series.length > 0 && (
                <HighchartsReact
                    ref={chartRef}
                    highcharts={Highcharts}
                    options={{
                        chart: {
                            type: 'xrange',
                            reflow: true,
                            // marginRight: Math.floor(width * 0.15),
                            width: Math.floor(width * 0.95),
                            height: height,
                            marginTop: 16,
                            marginBottom: 16
                        },
                        title: null,
                        tooltip: {
                            style: {
                                color: '#ffff',
                                position: 'inherit',
                                transformStyle: 'flat',
                                zIndex: 9
                            },
                            className: 'teste-tooltip',
                            backgroundColor: '#ffff',
                            borderColor: '#C8CCD4',
                            shadow: true,
                            formatter: function () {
                                return renderPointForm(this.point)
                            }
                        },
                        xAxis: {
                            title: '',
                            min: 0,
                            max: 100,
                            tickLength: 0,
                            lineColor: 'transparent',
                            labels: {
                                enabled: false
                            }
                        },
                        yAxis: {
                            title: '',
                            gridLineWidth: 0,
                            endOnTick: false,
                            categories: [...categories],
                            reversed: true,
                            style: {
                                background: 'blue'
                            },
                            labels: {
                                enabled: true,
                                style: {
                                    fontFamily: 'SourceSansPro-Regular',
                                    color: 'var(--gray-1000)',
                                    fontSize: '14px',
                                    borderColor: 'red',
                                    borderWidth: 1
                                }
                            }
                        },
                        legend: {
                            enabled: false
                        },

                        plotOptions: {
                            series: {
                                states: {
                                    hover: {
                                        enabled: false
                                    }
                                },
                                dataLabels: {
                                    enabled: true
                                    // inside: false
                                },
                                grouping: false
                            }
                        },
                        series
                    }}
                />
            )}
        </Container>
    )
}

const Container = styled.div`
    width: 100%;
    height: 100%;
    display: grid;
    overflow: auto;
`

export default React.memo(TrackBar, arePropsEquals)

function arePropsEquals(oldProps: LiveReactChartProps<ChartState>, newProps: LiveReactChartProps<ChartState>) {
    return (
        oldProps.height == newProps.height &&
        oldProps.width == newProps.width &&
        oldProps.state.endHistory == newProps.state.endHistory &&
        Object.is(oldProps.widget, newProps.widget)
    )
}
